import React from 'react';
import { Label as BaseLabel } from '@qga/roo-ui/components';

// We have to override the default roo-ui label to remove the margin bottom;

const Label = (props) => <BaseLabel mb={0} {...props} />;

export default Label;
